import React from 'react';
import { Label } from 'reactstrap';
import { DatePickerInput, DatesProvider } from '@mantine/dates';

/**
 * Compound field combining a date picker with a "Sin Fecha Límite" checkbox.
 * When the checkbox is checked the date is cleared and the picker is disabled.
 */
const DeadlineDateField = ({ value, noDeadline, onChange, onNoDeadlineChange, error }) => (
	<>
		<div className='d-flex align-items-center justify-content-between mb-1'>
			<Label className='form-label mb-0'>
				Fecha Límite{!noDeadline && <span className='text-danger'> *</span>}
			</Label>
			<div className='form-check mb-0 ms-2'>
				<input
					className='form-check-input'
					type='checkbox'
					id='no_deadline'
					checked={noDeadline || false}
					onChange={e => onNoDeadlineChange(e.target.checked)}
				/>
				<label className='form-check-label small' htmlFor='no_deadline'>
					Sin Fecha Límite
				</label>
			</div>
		</div>
		<DatesProvider settings={{ locale: 'es-mx', firstDayOfWeek: 1, weekendDays: [0], timezone: 'UTC' }}>
			<DatePickerInput
				placeholder={noDeadline ? 'Sin fecha límite' : 'Seleccione fecha'}
				value={value}
				onChange={onChange}
				valueFormat='DD-MM-YYYY'
				clearable
				disabled={noDeadline}
				error={!noDeadline ? error : null}
			/>
		</DatesProvider>
	</>
);

export default DeadlineDateField;
